exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.selectedvalue[data-v-e5df1456]{width:20px;display:inline-block;text-align:center\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/shipper/src/components/common/depotDropdown.vue"],"names":[],"mappings":";AACA,gCAAgC,WAAW,qBAAqB,iBAAiB;CAChF","file":"depotDropdown.vue","sourcesContent":["\n.selectedvalue[data-v-e5df1456]{width:20px;display:inline-block;text-align:center\n}"],"sourceRoot":""}]);

// exports
